import React, { useState } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Modal from 'tbk-components/src/components/Modal';
import HubSpotEmbedForm, { IHubSpotEmbedFormProps } from '../HubSpotEmbedForm';

export interface IFormLightboxButtonProps extends IBaseElementProps {
	formLightboxButton?: ILink;
	buttonColor?: 'Primary' | 'Secondary' | 'Dark' | 'Light';
	buttonSize?: 'md' | 'sm';
	form?: IHubSpotEmbedFormProps;
	modalTitle?: string;
	/**
	 * @control richtext
	 */
	modalContent?: string;
	modalLogo?: IImage;
}

/**
 * Form Trigger Button
 * @icon button
 * @block
 */
const FormLightboxButton: React.FC<IFormLightboxButtonProps> = ({
	id,
	className,
	classNames = [],
	formLightboxButton,
	buttonColor = 'Primary',
	buttonSize = 'md',
	form,
	modalTitle,
	modalContent,
	modalLogo,
}) => {
	const [showModal, setShowModal] = useState(false);

	return (
		<div
			id={id}
			className={className || cn('form-trigger-button', ...classNames)}
		>
			{!form?.hubSpotEmbedCode &&
				formLightboxButton?.href &&
				formLightboxButton?.label && (
					<Button
						{...formLightboxButton}
						className={cn('btn', {
							[`btn-${buttonColor?.toLowerCase()}`]: buttonColor,
							[`btn-${buttonSize?.toLowerCase()}`]: buttonSize,
						})}
					/>
				)}
			{form?.hubSpotEmbedCode && (
				<>
					<Button
						className={cn('btn', {
							[`btn-${buttonColor?.toLowerCase()}`]: buttonColor,
							[`btn-${buttonSize?.toLowerCase()}`]: buttonSize,
						})}
						label={formLightboxButton?.label}
						aria-label={formLightboxButton?.label}
						onClick={() => {
							setShowModal((s) => !s);
						}}
					/>
					{showModal && (
						<Modal
							className="lightbox-form__modal"
							onCancel={() => {
								setShowModal(false);
							}}
						>
							<div
								className={`lightbox-form__container py-5 pt-7 px-3 p-md-7 p-lg-9 ${
									!(
										modalTitle ||
										(modalContent &&
											modalContent !== '<br>') ||
										modalLogo
									)
										? 'single-col'
										: ''
								}`}
							>
								<div className="lightbox-form__container-inner">
									{(modalTitle ||
										(modalContent &&
											modalContent !== '<br>') ||
										modalLogo) && (
										<div className="lightbox-form__left">
											{modalTitle && (
												<h2>{modalTitle}</h2>
											)}
											{modalContent &&
												modalContent !== '<br>' && (
													<div
														dangerouslySetInnerHTML={{
															__html: modalContent,
														}}
													/>
												)}
											{modalLogo?.src && (
												<div className="lightbox-form__logo">
													<Image {...modalLogo} />
												</div>
											)}
										</div>
									)}
									<div className="lightbox-form__right">
										<HubSpotEmbedForm {...form} />
									</div>
								</div>
							</div>
						</Modal>
					)}
				</>
			)}
		</div>
	);
};

export default FormLightboxButton;
